import {Component, OnInit} from '@angular/core';
import {dateFormat} from '../global';
@Component({
  selector: 'app-example',
  templateUrl: './example.component.html',
  styleUrls: ['./example.component.scss']
})
export class ExampleComponent implements OnInit {
  constructor() {
  }
  dateFormat = dateFormat;
  gutter = [{xs: 8, sm: 16, md: 24}, {xs: 8, sm: 12}];
  checkOptionsOne = [
    {label: 'Apple', value: 'Apple', checked: true},
    {label: 'Pear', value: 'Pear'},
    {label: 'Orange', value: 'Orange'}
  ];

  ngOnInit(): void {
  }

}
